import analyzerLines from '../../content/analyzer-lines.json';
import revealPhrasings from '../../content/reveal-phrasings.json';
import revealSubtitles from '../../content/reveal-subtitles.json';

export async function getAnalyzerLines() {
  return analyzerLines;
}

export async function getRevealPhrasing(index, name) {
  const phrasing = revealPhrasings[index % revealPhrasings.length];
  return phrasing.replaceAll('[Name]', name);
}

export async function getRevealSubtitle(index) {
  return revealSubtitles[index % revealSubtitles.length];
}

export function pickAnalyzerLines(pool, count) {
  const shuffled = [...pool].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}

export function totalRevealPhrasings() {
  return revealPhrasings.length;
}
